import styled from 'styled-components';

export const Content = styled.select`
  width: ${(props) => props.width ?? 'auto'};
  text-align: center;
  font-size: 13px;
  border: 0;
  border-left: 1px solid #3d4952;
  background-color: #1a2429;
  color: #e6eaec;
  outline: none;
  cursor: pointer;
  flex-grow: 1;
  transition: box-shadow 0.15s ease-in-out;
  option {
    background-color: #1a2429;
    color: #e6eaec;
  }
  &:focus {
    box-shadow: inset 0 0 0 1px #47b972;
  }
`;
